<script>
  import { onMount } from "svelte";
  import VideoItem from "@/components/molecules/VideoItem.svelte";
  import VideoOverlayEmbed from "@/components/molecules/VideoOverlayEmbed.svelte";
  import * as css from "@/utils/css";
  import { getVideoById, signUpUser } from "@/api/index.js";
  import ImageUrls from "@/constants/ImageUrls";

  export let data;

  export let { item, videoId } = data;

  $: hasData = typeof item === "object" && item;

  onMount(async () => {
    if (!hasData) {
      try {
        item = await getVideoById(window.fetch, videoId);
      } catch (e) {
        console.warn(e);
      }
    }
  });
</script>

<main>
  {#if hasData}
    <div class="swipe-holder relative flex flex-col rounded-2xl">
      <VideoItem {item} showDefaultOverlay={false} heightClass="grow" />

      <a
        href="/?referrer=embed"
        target="_blank"
        class={`${css.topLeftAlign} p-md`}
      >
        <img
          class="max-w-[48px] object-contain"
          src={ImageUrls.MOJ_ICON}
          alt="logo"
        />
      </a>

      <VideoOverlayEmbed {item} />
    </div>
  {/if}
</main>
